import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ButtonComponent } from 'projects/ui-library/src/lib/components/button/button.component';

@Component({
    selector: 'app-alert',
    imports: [
        MatDialogModule,
        ButtonComponent
    ],
    standalone: true,
    templateUrl: './alert.component.html',
    styleUrl: './alert.component.scss'
})
export class AlertComponent {
    constructor(
        public dialogRef: MatDialogRef<AlertComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) { }

    dismiss(): void {
        this.data.dismissed = true
        this.dialogRef.close(this.data);
    }

    ok(): void {
        this.dialogRef.close();
    }
}
